import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageMeta from '../components/PageMeta';
import Navbar from '../components/Navbar';
import StudioHero from '../components/StudioHero';
import FlagshipSection from '../components/FlagshipSection';
import AboutStudio from '../components/AboutStudio';
import InceptumConceptSection from '../components/InceptumConceptSection';
// import FutureTitlesSection from '../components/FutureTitlesSection';
import PartnershipsSection from '../components/PartnershipsSection';
import ContactSection from '../components/ContactSection';
import StudioFooter from '../components/StudioFooter';
import styles from './HomePage.module.css';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const target = location.hash ? location.hash.replace('#', '') : null;
    if (!target) return;
    const el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  return (
    <>
      <PageMeta
        title="StratMech Studios - Thoughtful Strategy Board Games"
        description="StratMech Studios creates strategy board games built on meaningful decisions. Home of INCEPTUM: Dawn of Civilizations - a non-combat civilization board game."
        path="/"
        ogDescription="Thoughtful strategy board games built on meaningful decisions. Explore INCEPTUM: Dawn of Civilizations, a non-combat civilization board game shaped by timing and trade-offs."
      >
        <link rel="preload" as="image" href="/images/webp/StratMechHeroImage.webp" fetchpriority="high" />
      </PageMeta>
      <Navbar />
      <main className={styles.homeMain}>
        <StudioHero />
        <FlagshipSection />
        {/* <FutureTitlesSection /> */}
        <InceptumConceptSection />
        <AboutStudio showTeamLink />
        <PartnershipsSection />
        {/* Team content now lives on the /about-us page under "The Team Behind INCEPTUM" */}
        {/* ContactSection removed; contact info now lives in footer */}
        {/* <ContactSection /> */}
      </main>
      <StudioFooter />
    </>
  );
}
